import { UsersList } from "../../users/components";

function Users() {
  return <UsersList></UsersList>;
}

export default Users;
